import QuoteTagOptions from './QuoteTagOptions'

export * from './QuoteTagOptions'
export default QuoteTagOptions
